import { JAPIAutoCompleteLoader } from "api/publications/JAPIAutoCompleteLoader";
import { addParam, push } from "api/search/filterUrlMaker";
import React from "react";
import { ListGroup } from "react-bootstrap";

export function AutoSuggestions({ keyword, setAcVisible, language, category, acFilter, filter = {}, ...props }) {
  return (
    <JAPIAutoCompleteLoader
      {...props}
      keyword={keyword}
      language={language}
      category={category}
      render={(suggestions) => (
        // Example suggestion: {CategoryName: 'Analyst', CategoryValue: 'Jordan Rochester', CategoryLang: 'ja'}
        <ListGroup>
          {suggestions
            .filter((suggestion) => suggestion.CategoryName === category)
            .map((suggestion, index) => (
              <div
                key={index}
                className="list-group-item cursor-pointer hover-primary"
                onClick={() => onClick(suggestion, setAcVisible)}
                onMouseDown={(ev) => ev.preventDefault()}
              >
                {suggestion.CategoryValue}
              </div>
            ))}
        </ListGroup>
      )}
    />
  );
}

const onClick = (suggestion, setAcVisible) => {
  setAcVisible(false);
  const lang = suggestion.CategoryLang;

  if (suggestion.CategoryName === "Analyst") {
    push(addParam(`analysts.name.${lang}`, suggestion.CategoryValue));
  } else if (suggestion.CategoryName === "CompanyWithTicker") {
    push(addParam(`companies.nameWithTicker.${lang}`, suggestion.CategoryValue));
  } else if (suggestion.CategoryName === "Report Titles") {
    push(addParam(`reportTitles.${lang}`, suggestion.CategoryValue));
  } else if (suggestion.CategoryName === "Country") {
    push(addParam(`countries.${lang}`, suggestion.CategoryValue));
  } else if (suggestion.CategoryName === "Region") {
    push(addParam(`regions.${lang}`, suggestion.CategoryValue));
  } else if (suggestion.CategoryName === "Currency") {
    push(addParam(`currencies.${lang}`, suggestion.CategoryValue));
  } else if (suggestion.CategoryName === "Trade Ideas") {
    push(addParam(`tradeIdeas.${lang}`, suggestion.CategoryValue));
  } else {
    console.error("unhandled", suggestion);
  }
};
